import { Map } from 'immutable';
import * as core from './core';

export default function user(state = Map(), action) {
    switch (action.type) {
        case 'LOGIN_USER':
            return core.loginUser(state, action.user);
        case 'LOGOUT_USER':
            return core.logoutUser(state);
    }
    return state;
}



// WEBPACK FOOTER //
// ./data/user/reducer.js